import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const UnsavedChangesAlert = ({ hasUnsavedChanges }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        // Standard message for modern browsers
        const message = "Are you sure you want to leave? You're nearly done with your will—unsaved changes may be lost.";
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    };

    const handlePopState = (e) => {
      if (hasUnsavedChanges) {
        const confirmLeave = window.confirm("Are you sure you want to leave? You're nearly done with your will—unsaved changes may be lost.");
  
        if (!confirmLeave) {
          e.preventDefault();
          window.history.pushState(null, '', window.location.pathname);
        }
      }
    };

    // Add event listeners when component mounts
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    // Block navigation when there are unsaved changes
    if (hasUnsavedChanges) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = null;
    }

    // Remove event listeners when component unmounts
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
      window.onbeforeunload = null;
    };
  }, [hasUnsavedChanges, navigate]);

  // This component doesn't render anything visible
  return null;
};

export default UnsavedChangesAlert; 